
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReachTypeAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReachType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_curated"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":135}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/SupplierFragments.graphql\"\n\nfragment ReachTypeAttributes on ReachType {\n    id\n    value\n    is_curated\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/SupplierFragments.graphql").definitions));


      module.exports = doc;
    
